<template>
  <div style="margin-left: 30px" v-loading="loading">
    <div style="margin-bottom: 20px; text-align: center">
      <el-menu
        style="margin-top: -20px"
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleOpen"
      >
        <el-menu-item index="0">
          <span>基本设置</span>
        </el-menu-item>
        <el-menu-item index="1">
          <span>权限设置</span>
        </el-menu-item>
        <el-menu-item index="2">
          <span>修改记录</span>
        </el-menu-item>
        <el-tooltip class="item" effect="light" placement="left" :value="true">
          <div slot="content" style="color: #f56c6c; font-size: 14px">
            <b><i class="el-icon-message-solid"></i> 修改配置后请点击此处保存</b>
          </div>
          <el-button
            style="text-align: center; float: right; margin-top: 26px"
            size="small"
            type="primary"
            @click="submit"
            >确定</el-button
          >
        </el-tooltip>
      </el-menu>
    </div>

    <div style="margin-top: 10px" v-show="activeIndex == 0" v-if="$route.query['id'] > 0 && form.product_id > 0">
      <product-head
        style="margin-left: 120px"
        :params="params"
        @changeHead="changeHead"
      ></product-head>
    </div>
    <div v-if="activeIndex==1 && $route.query['id'] > 0 && form.product_id > 0">
      <el-form :model="form" label-width="200px" ref="form">
        <el-form-item label="可用模块：" prop="permissions" :label-width="formLabelWidth">
          <el-checkbox-group v-model="form.permissions">
            <el-checkbox label="1">选科管理</el-checkbox>
            <el-checkbox label="2" v-if="form.permissions.includes('1')">新高考模式</el-checkbox>
            <el-checkbox label="3" v-if="form.permissions.includes('1')">四点半模式</el-checkbox>
            <el-checkbox label="4">排课管理</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="activeIndex==2 && $route.query['id'] > 0 && form.product_id > 0">
      <recorder :customer_id="$route.query['id']" :product_id="form.product_id" :product_list="params.product_list"></recorder>
    </div>
  </div>
</template>
<script>
import ProductHead from "~/views/order/partial/product_head.vue"; //加载基本设置
import OrderService from "~/services/order";
import Recorder from "~/views/order/recoder/base.vue";
export default {
  name: 'teacherFilesConfigure',
  components: {
    ProductHead,
    Recorder
  },
  props: {
    params: {
      required: true,
    },
  },
  data() {
    return {
      activeIndex: "0",
      loading: false,
      formLabelWidth: '120px',
      form: {
        //基本设置
        order_id: "",
        product_id: "",
        type: '',
        end_at: '',
        start_at: '',
        memo: '',
        is_enable: false,
        permissions: [],
      },
    }
  },
  created() {
    this.form = Object.assign(this.form, this.params.config);
    this.form.order_id = this.params.order_id;
    this.form.product_id = this.params.product_id;
    this.form.type = this.params.open_state;
    this.form.end_at = this.params.end_at;
    this.form.start_at = this.params.start_at;
    console.log("课后服务选课", this.params, this.params.config.type, this.form, this.form.permissions);
  },
  methods: {
    handleOpen(key, keyPath) {
      this.activeIndex = key;
    },
    /**
     * 提交
     * */
    submit() {
      console.log('课后服务选课-配置提交', this.form);
      OrderService.reviseProduct(this.form).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.msg == "success" ? Params.REVISE_NOTICE : res.msg,
            type: "success",
          });
        }
      });
    },
    /**
     * 修改头部信息（开通时间及产品类型）
     * */
    changeHead(data) {
      console.log('更新基本设置', data);
      this.form.type = data.type;
      this.form.start_at = data.start_at;
      this.form.end_at = data.end_at;
      this.form.memo = data.memo;
      this.form.is_enable = data.is_enable;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/order/flexSchedulingConfigure.vue